// Shared client for the local Logos bridge (ADR-0029/0030). The bridge is a
// separate FastAPI service on the user's machine; every call must carry the
// custom header (see bridge/security.py), which forces a CORS preflight.
export const BRIDGE_BASE = 'http://127.0.0.1:5555';
export const BRIDGE_HEADER = { 'X-Shepwise-Bridge': '1' };
export const BRIDGE_PROBE_TIMEOUT_MS = 1500;
export const BRIDGE_REQUEST_TIMEOUT_MS = 5000;

export async function bridgeFetch(path, options = {}, timeoutMs = BRIDGE_REQUEST_TIMEOUT_MS) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        return await fetch(`${BRIDGE_BASE}${path}`, {
            ...options,
            headers: { ...BRIDGE_HEADER, ...(options.headers || {}) },
            signal: controller.signal
        });
    } finally {
        clearTimeout(timer);
    }
}

// Probes /health once. Returns the parsed body ({status, logos_data_found,
// version}) when the bridge answered with status "ok", otherwise null.
export async function probeHealth() {
    try {
        const response = await bridgeFetch('/health', {}, BRIDGE_PROBE_TIMEOUT_MS);
        const body = await response.json();
        if (response.ok && body.status === 'ok') return body;
    } catch (e) {
        // Unreachable bridge is an expected state, not an error.
    }
    return null;
}
